module.exports = __webpack_public_path__ + "img/14-2.e73839bb.png";